// assets
import { CalendarOutlined, DashboardOutlined } from '@ant-design/icons';

// icons
const icons = {
  CalendarOutlined,
  DashboardOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Início',
  type: 'group',
  children: [
    {
      id: 'appointments',
      title: 'Atendimentos',
      type: 'item',
      url: '/inicio/atendimentos',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'calendar',
      title: 'Calendário',
      type: 'item',
      url: '/inicio/calendario',
      icon: icons.CalendarOutlined,
      breadcrumbs: false
    },
    {
      id: 'dashboard-page',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
